import React from "react";
import { Icon, IconButton, Hidden, MenuItem, Avatar } from "@material-ui/core";
import { MatxMenu, MatxToolbarMenu } from "matx";
import { setLayoutSettings } from "app/redux/actions/LayoutActions";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { merge } from "lodash";
import sctregLogo from '../../views/sessions/login/sctregLogo.png';
import { Link } from "react-router-dom";
import LockOpenIcon from '@material-ui/icons/LockOpen';
import useAuth from "app/hooks/useAuth";
import history from "history.js";
import {clearAllCachedItem} from "app/c1utils/C1Caches";

const useStyles = makeStyles(({ palette, ...theme }) => ({
  root: {
    backgroundColor: '#3C77D0',
    borderColor: palette.divider,
    display: "table",
    height: "var(--topbar-height)",
    borderBottom: "1px solid transparent",
    paddingTop: "0rem",
    paddingBottom: "0rem",
    zIndex: 98,
    paddingLeft: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "1rem",
    },
  },
  brandText: {
    color: palette.primary.contrastText,
  },
  userMenu: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    borderRadius: 24,
    padding: 4,
    "& span": {
      margin: "0 8px",
      // color: palette.text.secondary
    },
    "&:hover": {
      backgroundColor: palette.action.hover,
    },
  },
  menuItem: {
    minWidth: 185,
  },
}));

const Layout2Topbar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { settings } = useSelector(({ layout }) => layout);
  const { logout, user } = useAuth();

  const updateSidebarMode = (sidebarSettings) => {
    dispatch(
      setLayoutSettings(
        merge({}, settings, {
          layout2Settings: {
            leftSidebar: {
              ...sidebarSettings,
            },
          },
        })
      )
    );
  };

  const handleSidebarToggle = () => {
    let { layout2Settings } = settings;

    let mode =
      layout2Settings.leftSidebar.mode === "close" ? "mobile" : "close";

    updateSidebarMode({ mode });
  };

  const handleSignOut = async () => {
    try {
      await logout();
      history.push({
        pathname: "/session/signin"
      });
      
      clearAllCachedItem();

    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className={clsx("relative w-full", classes.root)}>
      <div className="flex justify-between items-center h-full">
        <div className="flex items-center h-full">
          <img
            className="h-40"
            src={sctregLogo}
            alt=""
          />
          <span className={clsx("font-medium text-24 mx-4", classes.brandText)}>
            EAC SCT
          </span>
        </div>
        <div className="mx-auto"></div>
        <div className="flex items-center">
          {user && <MatxToolbarMenu offsetTop="80px">
            {/* <MatxSearchBox />

            <NotificationBar /> */}


            <MatxMenu
              menuButton={
                <div className={classes.userMenu}>
                  <span className={classes.brandText}>
                    Hi <strong>{user?.name}</strong>
                  </span>
                  <span>
                    <Avatar className="cursor-pointer" src={`${process.env.PUBLIC_URL}/assets/images/avatars/001-man.svg`} />
                  </span>
                </div>
              }
            >
              <MenuItem className={classes.menuItem}>
                <Link className={classes.menuItem} to="/">
                  <Icon> home </Icon>
                  <span className="pl-4"> Home </span>
                </Link>
              </MenuItem>
              <MenuItem className={classes.menuItem}>
                {user && <Link className={classes.menuItem} to={`${process.env.PUBLIC_URL}/accountUser/manageUsers/edit/${user.username}?profile`}>
                  <Icon> person </Icon>
                  <span className="pl-4"> Profile </span>
                </Link>}
              </MenuItem>
              <MenuItem className={classes.menuItem}>
                <Link
                  className={classes.menuItem}
                  to={"/profile/updatePassword"}>
                  <LockOpenIcon />
                  <span className="pl-4"> Change password </span>
                </Link>
              </MenuItem>
              <MenuItem onClick={handleSignOut} className={classes.menuItem}>
                <Icon> power_settings_new </Icon>
                <span className="pl-4"> Logout </span>
              </MenuItem>
            </MatxMenu>
          </MatxToolbarMenu> }

          <Hidden mdUp>
            <IconButton className="text-white" onClick={handleSidebarToggle}>
              <Icon>menu</Icon>
            </IconButton>
          </Hidden>
        </div>
      </div>
    </div>
  );
};

export default Layout2Topbar;
